<template>
    <div>
        <b-button variant="link" size="sm" @click="isOpen = true"> {{ $t('producerSubscriptions.cancelSubscription') }} </b-button>

        <b-modal
            v-model="isOpen"
            :title="$t('producerSubscriptions.cancelSubscription')"
            :ok-title="$t('producerSubscriptions.submit')"
            :cancel-title="$t('cancel')"
            :ok-disabled="loading"
            @ok.prevent="deactivate"
        >
            <p>{{ $t('producerSubscriptions.cancelDescription') }}</p>
            <ErrorMessage v-if="error" :value="error" />
        </b-modal>
    </div>
</template>

<script>
    import ErrorMessage from '@/components/common/ErrorMessage.vue';
    import spaceService from '@/services/spaceService';

    export default {
        components: {
            ErrorMessage,
        },
        props: {
            permissionId: Number,
            permission: String,
        },
        data() {
            return {
                isOpen: false,
                error: null,
                loading: false,
            };
        },
        methods: {
            async deactivate() {
                this.loading = true;
                this.error = null;
                try {
                    await spaceService.deactivatePermission(this.permissionId);

                    this.$emit('canceled');
                    this.isOpen = false;
                } catch (e) {
                    this.error = e.message;
                    this.$emit('error', e);
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
